import * as z from "zod/v4";

export const updateCheckoutOptimizationAnalyticsAssumptions = {
  name: "updateCheckoutOptimizationAnalyticsAssumptions" as const,
  input: z.object({ annualOrders: z.number().optional() }),
  output: z.null(),
};
